import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaRegCalendarCheck } from '@react-icons/all-files/fa/FaRegCalendarCheck';
import { FaTable } from '@react-icons/all-files/fa/FaTable';
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { FaClone } from '@react-icons/all-files/fa/FaClone';
import { FaCalendarAlt } from '@react-icons/all-files/fa/FaCalendarAlt';
import { FaCog } from '@react-icons/all-files/fa/FaCog';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import Breadcrumb from '../../../../commons/Breadcrumb';
import TileContainer, { TileItem } from '../../../../commons/TileContainer';
import TablaPeriodosPage from './tabla-periodos-page';
import DefinicionPeriodoPage from './definicion-periodo-page';
import DefinicionPeriodoFormPage from './definicion-periodo-form-page';
import PeriodoInstanciaPage from './periodo-instancia-page';
import PeriodoInstanciaFormPage from './periodo-instancia-form-page';

const tiles: TileItem[] = [
  { key: 'tabla-periodos',      label: 'Tabla de Periodos',    icon: <FaTable />,            color: '#0ea5e9' },
  { key: 'definicion-periodo',  label: 'Definición de Periodo', icon: <FaEdit />,             color: '#10b981' },
  { key: 'periodo-instancia',   label: 'Instancia de Periodo', icon: <FaClone />,            color: '#8b5cf6' },
];

function PeriodosIndex() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',                         icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',            icon: <FaCog /> },
        { label: 'Calendario',    to: '/configuracion/calendario', icon: <FaCalendarAlt /> },
        { label: 'Periodos',                                       icon: <FaRegCalendarCheck /> },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: '#0ea5e9' }}>
          <FaRegCalendarCheck style={s.icon} />
        </div>
        <div>
          <h2 style={s.title}>Periodos</h2>
          <p style={s.subtitle}>Configuración de periodos</p>
        </div>
      </div>

      <TileContainer
        tiles={tiles}
        onSelect={key => navigate(`/configuracion/calendario/periodos/${key}`)}
      />
    </div>
  );
}

export default function PeriodosPage() {
  return (
    <Routes>
      <Route path="/"                    element={<PeriodosIndex />} />
      <Route path="/tabla-periodos"                    element={<TablaPeriodosPage />} />
      <Route path="/definicion-periodo"                element={<DefinicionPeriodoPage />} />
      <Route path="/definicion-periodo/new"            element={<DefinicionPeriodoFormPage />} />
      <Route path="/definicion-periodo/:id/edit"      element={<DefinicionPeriodoFormPage />} />
      <Route path="/periodo-instancia"                element={<PeriodoInstanciaPage />} />
      <Route path="/periodo-instancia/new"            element={<PeriodoInstanciaFormPage />} />
      <Route path="/periodo-instancia/:id/edit"      element={<PeriodoInstanciaFormPage />} />
    </Routes>
  );
}

const s: Record<string, React.CSSProperties> = {
  page:        { display: 'flex', flexDirection: 'column', gap: 28 },
  header:      { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox:     { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon:        { fontSize: 22, color: '#fff', display: 'flex' },
  title:       { margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' },
  subtitle:    { margin: 0, fontSize: 13, color: '#64748b' },
};
